import React from "react";
import { useNavigate } from "react-router-dom";
import style from "../../PagesStyles/Heading.module.css"

export default function AdminBreadCrump({ title, companyName, module, page }) {
  const navigate = useNavigate();
  return (
    <div className={style.adminDesktopBreadCrumpMainBox}>
      <h4 className={style["bredcrumb-title"]}>{title}</h4>
      <div className={style.adminDesktopBreadCrumpLinks}>
        <p onClick={() => navigate("/adminhome")}>{companyName} </p>
        <p>{` > `}</p>
        <p>{module}</p>
        <p>{` > `}</p>
        <p style={{ textDecoration: "underline" }}>
          <strong>{page}</strong>
        </p>
      </div>
    </div>
  );
}
